//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EnableFormSubmissionViaApi: FeatureFlag = {"Id":"EnableFormSubmissionViaApi","Label":"[10.12]Enable form submission via API.","Impact":"Saved forms can be completed via API.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
